import React from 'react';
import { COLORS, FONTS } from '../../../styles/tokens';
import { fieldLabelStyle } from './IconField';
import SegmentedControl from './SegmentedControl';

const UNITS = [
  { value: 'tons', label: 'Tonn' },
  { value: 'bags', label: 'Sekker' },
];

// Stor mengdefelt + enhetsvelger. label kan overstyres (f.eks. «Omtrentlig mengde (valgfri)»).
export default function QuantityField({ value, onChange, unit, onUnitChange, label = 'Mengde' }) {
  return (
    <div>
      <label htmlFor="new-order-quantity" style={{ ...fieldLabelStyle, margin: '4px 0 6px' }}>{label}</label>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <input
          id="new-order-quantity"
          type="number" inputMode="decimal" min={0.1} step={0.1}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="0"
          style={{
            flex: 1, minWidth: 0, height: 60, borderRadius: 14, background: COLORS.white, boxSizing: 'border-box',
            border: `2px solid ${COLORS.brandPanel}`, padding: '0 16px', outline: 'none',
            fontFamily: FONTS.display, fontWeight: 700, fontSize: 34, color: COLORS.textDark,
          }}
        />
        <SegmentedControl options={UNITS} value={unit} onChange={onUnitChange} ariaLabel="Enhet" />
      </div>
    </div>
  );
}
